export const MstaFontFamily = [
    'Noto Sans JP', 
    'system-ui', 
    '-apple-system', 
    '"Segoe UI"', 
    'Roboto', 
    '"Helvetica Neue"', 
    'Arial',
    '"Noto Sans"',
    '"Liberation Sans"',
    'sans-serif'
  ].join(',')